import { useContext } from 'react'
import { useQuery } from '@tanstack/react-query'
import { getApi } from '@BUP/services/Axios'
import { RoleContext } from '@BUP/contexts/RoleContext'
import { ECE, ASSISTANT } from '@BUP/constants'

const fetchCurrentCourses = async () => {
  const client = await getApi('schools', { version: 4 })
  const { data } = await client.get('current-enrollment/current-registrations')
  return data
}

export const useGetCurrentCourses = () => {
  const role = useContext(RoleContext)

  const isEnabled = role?.type !== ECE && role?.type !== ASSISTANT

  const query = useQuery({
    queryKey: ['current-courses'],
    queryFn: fetchCurrentCourses,
    enabled: isEnabled,
    staleTime: 1000 * 60 * 10
  })

  // Si es ECE o ASSISTANT, retorna early
  if (!isEnabled) {
    return {
      courses: [],
      error: null,
      isLoading: false
    }
  }

  return {
    courses: query.data || [],
    error: query.error,
    isLoading: query.isLoading
  }
}
